var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"sad-config-ui"}},[_c('app-header'),_c('v-content',{staticStyle:{"margin-top":"64px"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.currentRouteName)+" ")]),_c('router-view')],1)],1)],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }